export const SET_APP_BUSY = 'SET_APP_BUSY'
export const SET_MAP_LOADED = 'SET_MAP_LOADED'

export interface AppState {
    busy: boolean
    loadingMap: boolean
}

interface SetAppBusyAction {
    type: typeof SET_APP_BUSY
    busy: boolean
}

interface SetMapLoadedAction {
    type: typeof SET_MAP_LOADED
    loading: boolean
}

type AppAction = SetAppBusyAction | SetMapLoadedAction

/**
 * Set app busy
 */
function setAppBusy(state: AppState, busy: boolean): AppState {
    return {
        ...state,
        busy: busy,
    }
}

function setMapLoaded(state: AppState, loading: boolean): AppState {
    return {
        ...state,
        loadingMap: loading,
    }
}

/**
 * Reducer for app state in store
 */
export default function reducer(state: AppState = [] as unknown as AppState, action: AppAction): AppState {
    switch (action.type) {
        case SET_APP_BUSY: return setAppBusy(state, action.busy)
        case SET_MAP_LOADED: return setMapLoaded(state, action.loading)
        default: return state
    }
}
